import GradePage from "@/pages/GradePage";
export default function GradeAlgebra2() {
  return <GradePage grade="11" />;
}
